import React from 'react';
import {View} from 'react-native';

import sy from '~/styles';
import {Dialog, Text, RobTaskIcon} from '~/components/controls';
import {ROB_TASK_STATUS_LABELS} from '~/types/rob';

import ReportIcon from '~/images/md-icons/report/materialicons/24px.svg';
import PropTypes from 'prop-types';

const RobReasonsDialog = ({
  component_id,
  rob_code,
  tasks: request_tasks,
  rob,
  rob_components,
  onDismiss,
}) => {
  let rob_codes;
  if (rob_code) {
    rob_codes = [rob_code];
  } else {
    rob_codes = [
      ...new Set(
        request_tasks
          .filter((item) => item.component_id === component_id)
          .map((item) => item.rob_code),
      ),
    ];
  }

  return (
    <Dialog
      visible={true}
      title={
        <View style={[{width: '100%'}, sy['flex-row'], sy['justify-between']]}>
          {rob_codes.map((rob_code) => (
            <Text key={rob_code} style={[sy.largePlus, sy.truncate]}>
              {rob_code}
              &nbsp;&middot;&nbsp;
              {rob_components[rob_code].description}
            </Text>
          ))}
        </View>
      }
      buttons={[
        {
          text: 'OK',
          textStyle: {color: '#972727'},
          onPress: onDismiss,
        },
      ]}
      onDismiss={onDismiss}>
      <View style={{paddingVertical: 16}}>
        {Object.values(rob?.components ?? {})
          .filter((item) => rob_codes.includes(item.rob.code))
          .map(({status, denialReasons}) => (
            <React.Fragment key={status.code}>
              <View style={[sy['flex-row'], sy['py-4']]}>
                <RobTaskIcon statuses={[status.code]} height="24" width="24" />
                <Text style={[sy['pl-4']]}>
                  {ROB_TASK_STATUS_LABELS[status.code]}
                </Text>
              </View>
              {denialReasons?.map((reason) => (
                <View key={reason.code} style={[sy['flex-row'], sy['py-4']]}>
                  <View>
                    <ReportIcon height={24} width={24} />
                  </View>
                  <Text style={[sy['pl-4']]}>
                    {reason.lessorRemark ?? reason.code}
                  </Text>
                </View>
              ))}
            </React.Fragment>
          ))}
      </View>
    </Dialog>
  );
};
RobReasonsDialog.propTypes = {
  component_id: PropTypes.any,
  rob_code: PropTypes.any,
  tasks: PropTypes.any,
  rob: PropTypes.any,
  rob_components: PropTypes.any,
  onDismiss: PropTypes.any,
};

export default RobReasonsDialog;
